import { useNavigate } from "react-router-dom";
import { Heart, MapPin } from "@phosphor-icons/react";
import { fileUrl, formatINR } from "@/lib/api";
import { StarRating } from "@/components/StarRating";

export const PropertyCard = ({ property, isFavorite, onToggleFavorite, className = "" }) => {
  const navigate = useNavigate();
  const img = fileUrl(property.images?.[0]);

  return (
    <div
      data-testid={`property-card-${property.id}`}
      onClick={() => navigate(`/property/${property.id}`)}
      className={`group cursor-pointer overflow-hidden rounded-2xl border border-stone-200 bg-white transition-transform duration-300 ease-out hover:-translate-y-1 hover:shadow-lg ${className}`}
    >
      <div className="relative h-44 overflow-hidden">
        {img ? (
          <img src={img} alt={property.name} className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105" />
        ) : (
          <div className="flex h-full items-center justify-center bg-stone-100 text-stone-400">No image</div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
        <span className="absolute left-3 top-3 rounded-full bg-white/90 px-3 py-1 text-xs font-medium text-stone-800 backdrop-blur">
          {property.category}
        </span>
        {onToggleFavorite && (
          <button
            data-testid={`favorite-btn-${property.id}`}
            onClick={(e) => {
              e.stopPropagation();
              onToggleFavorite(property.id);
            }}
            className="absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-full bg-white/90 backdrop-blur transition-colors hover:bg-white"
            aria-label="Toggle favorite"
          >
            <Heart size={18} weight={isFavorite ? "fill" : "regular"} className={isFavorite ? "text-red-500" : "text-stone-700"} />
          </button>
        )}
      </div>
      <div className="p-4">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-heading text-base font-semibold leading-tight text-stone-900 line-clamp-1">{property.name}</h3>
          <StarRating rating={property.rating} />
        </div>
        <p className="mt-1 flex items-center gap-1 text-sm text-stone-500">
          <MapPin size={14} weight="fill" className="text-primary" /> {property.location}
        </p>
        <p className="mt-1 text-xs text-stone-500 line-clamp-1">{property.short_description}</p>
        <div className="mt-3 flex items-center justify-between">
          <div>
            <span className="font-heading text-lg font-bold text-stone-900">{formatINR(property.prices?.starting)}</span>
            <span className="text-xs text-stone-500"> onwards</span>
          </div>
          <span className="text-xs text-stone-400">{property.reviews_count} reviews</span>
        </div>
        <button
          data-testid={`view-details-${property.id}`}
          onClick={(e) => { e.stopPropagation(); navigate(`/property/${property.id}`); }}
          className="mt-3 w-full rounded-xl bg-primary py-2 text-sm font-medium text-white transition-colors hover:bg-green-900"
        >
          View Details
        </button>
      </div>
    </div>
  );
};
